import React, { useState, useEffect } from "react";
import instance from "../../instance";
import "../Customer.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SystemDetails = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");

  const [systemData, setSystemData] = useState(null);
  const [isEditingSystem, setIsEditingSystem] = useState(false);
  const [showPasswordSystem, setShowPasswordSystem] = useState(false);
  const [systemFormData, setSystemFormData] = useState({
    ServerSystem: "",
    UserSystem: "",
    PasswordSystem: "",
    DataEncryption: "",
  });

  useEffect(() => {
    if (code) {
      fetchSystemData();
    } else {
      toast.error("No code provided.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetchSystemData is recreated each render; adding it would refetch on every paint
  }, [code]);

  const fetchSystemData = async () => {
    try {
      const response = await instance.get(`system/by-code/${code}`);

      if (response.status !== 200) {
        throw new Error("Failed to fetch system data.");
      }

      const data = response.data;
      if (data && data.data) {
        setSystemData(data.data);
        setSystemFormData({
          ServerSystem: data.data.ServerSystem || "",
          UserSystem: data.data.UserSystem || "",
          PasswordSystem: data.data.PasswordSystem || "",
          DataEncryption: data.data.DataEncryption || "",
        });
      } else {
        toast.error("No system data found for the given code.");
      }
    } catch (error) {
      console.error("Error fetching system data:", error);
      toast.error("An error occurred while fetching system data.");
    }
  };

  const toggleEditSystem = () => {
    if (isEditingSystem) {
      saveSystemData();
    } else {
      setIsEditingSystem(true);
    }
  };

  const handleSystemInputChange = (event) => {
    const { id, value } = event.target;
    setSystemFormData({ ...systemFormData, [id]: value });
  };

  const saveSystemData = async () => {
    try {
      const response = await instance.put(
        `system/by-code/${code}`,
        systemFormData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      toast.success("System details updated successfully!");
      fetchSystemData(); // Fetch updated data instead of reloading the page
      setIsEditingSystem(false); // Exit editing mode
    } catch (error) {
      console.error("Error updating system details:", error);
      toast.error("An error occurred while updating system details.");
    }
  };
  const togglePasswordSystemVisibility = () => {
    setShowPasswordSystem(!showPasswordSystem);
  };

  return (
    <div>
      <main>
        <section id="system-section">
          <h2>System Details</h2>
          {systemData && (
            <ul>
              <li>
                Server System:{" "}
                <span
                  className={`info ${isEditingSystem ? "hidden" : ""}`}
                  id="info-ServerSystem"
                >
                  {systemData.ServerSystem}
                </span>
                {isEditingSystem && (
                  <input
                    className="input-field"
                    type="text"
                    id="ServerSystem"
                    value={systemFormData.ServerSystem}
                    onChange={handleSystemInputChange}
                    placeholder="Enter the server system"
                  />
                )}
              </li>
              <li>
                User System:{" "}
                <span
                  className={`info ${isEditingSystem ? "hidden" : ""}`}
                  id="info-UserSystem"
                >
                  {systemData.UserSystem}
                </span>
                {isEditingSystem && (
                  <input
                    className="input-field"
                    type="text"
                    id="UserSystem"
                    value={systemFormData.UserSystem}
                    onChange={handleSystemInputChange}
                    placeholder="Enter user system"
                  />
                )}
              </li>
              <li>
                Password System:{" "}
                <span
                  className={`info3 ${isEditingSystem ? "hidden" : ""}`}
                  id="info-PasswordSystem"
                >
                  {showPasswordSystem ? systemData.PasswordSystem : "••••••••"}
                </span>
                {isEditingSystem && (
                  <input
                    className="input-field"
                    type={showPasswordSystem ? "text" : "password"}
                    id="PasswordSystem"
                    value={systemFormData.PasswordSystem}
                    onChange={handleSystemInputChange}
                  />
                )}
                <button
                  className="show"
                  onClick={togglePasswordSystemVisibility}
                >
                  {showPasswordSystem ? "Hide" : "Show"}
                </button>
              </li>
              <li>
                Data Encryption:{" "}
                <span
                  className={`info ${isEditingSystem ? "hidden" : ""}`}
                  id="info-DataEncryption"
                >
                  {systemData.DataEncryption}
                </span>
                {isEditingSystem && (
                  <input
                    className="input-field"
                    type="text"
                    id="DataEncryption"
                    value={systemFormData.DataEncryption}
                    onChange={handleSystemInputChange}
                    placeholder="Enter data encryption"
                  />
                )}
              </li>
            </ul>
          )}
          <button className="edit-button" onClick={toggleEditSystem}>
            {isEditingSystem ? "Save" : "Update"}
          </button>
        </section>
      </main>
    </div>
  );
};

export default SystemDetails;
